/**
 *
 * formatImageUrl
 *
 * Calculate the image template url
 * @param {Object} config - The config responsible for generating the image template url.
 * @param {string} config.templateUrl - The image template url.
 * @param {string} config.formatInstructions - The formatted instructions to replace {formatInstructions} in the templateUrl.
 * @param {number} config.width - The width to replace {width} in the formatInstructions.
 * @param {number} config.height - The height to replace {height} in the formatInsructions.
 * @param {string} config.aspectRatio - The aspectRatio to replace {ar} in the formatInstructions.
 * @returns {string} - The formatted template url
 */

const formatImageUrl = ({
    templateUrl,
    formatInstructions,
    width,
    height,
    aspectRatio,
}) => {

    if (!templateUrl) {

        return '';

    }

    return templateUrl
        .replace("{formatInstructions}", formatInstructions)
        .replace("{width}", width)
        .replace("{height}", height)
        .replace("{ar}", aspectRatio);

};

export default formatImageUrl;
